const panels = {
  deleteDialogTitle: 'モデルの削除',
  deleteDialogBody: 'このCADモデルとすべての関連ファイルを削除しますか？',
  modelList: {
      emptyTitle: 'モデルなし',
      emptyDescription: 'CADファイルをアップロードしてください',
      setComparisonTarget: '比較対象に設定',
      delete: '削除',
      editClassification: '整理情報を編集',
      searchLabel: 'CADモデル検索',
      searchPlaceholder: 'ファイル名・機種・番号・タグで検索',
      folderFilter: 'フォルダで絞り込み',
      allFolders: 'すべてのフォルダ',
      unclassified: '未分類',
      noResults: '条件に一致するCADモデルはありません。',
    },
  classification: {
      optionalTitle: '整理情報（任意）',
      folder: 'フォルダ',
      folderPlaceholder: '例: パチンコ/機種A',
      machineModel: '機種',
      machineModelPlaceholder: '例: 機種A',
      managementNumber: '番号',
      managementNumberPlaceholder: '例: W136',
      tags: 'タグ',
      tagsPlaceholder: '例: DR、量産、要確認（カンマ区切り）',
      help: 'フォルダは「/」で階層化できます。タグはカンマ区切りで最大20件です。',
      editTitle: 'CADの整理情報を編集',
      editDescription: '解析結果は変えず、フォルダ・タグ・機種・番号だけを更新します。',
      batchEditTitle: '一括解析の整理情報を編集',
      batchEditDescription: '解析結果は変えず、一覧で使うフォルダ・タグ・機種・番号だけを更新します。',
      editAction: '整理',
      updateFailed: '整理情報を保存できませんでした。最新の状態を読み込み、処理完了後にもう一度お試しください。',
      saving: '保存中…',
    },
  modelSelect: {
      label: 'CADモデル',
      none: 'CADモデルを選択しない',
      empty: '解析済みCADモデルがありません',
      loadFailed: 'CADモデル一覧の取得に失敗しました',
    },
  upload: {
      dropLabel: 'CADファイルをドラッグ＆ドロップ',
      processing: '処理中... {{progress}}%',
      unsupportedFormat: '非対応のファイル形式です: {{extension}}\n対応形式: {{formats}}',
      noExtension: 'ファイル名に拡張子がありません: {{name}}\n対応形式: {{formats}}',
      rejectedFiles: '{{count}}件のファイルを除外しました:\n{{reasons}}',
      moreReasons: 'ほか{{count}}件の理由',
      batchLimited: '一度に解析できるのは{{max}}件までです。先頭{{max}}件のみ追加しました。',
      fileTooLarge: 'ファイルサイズが{{size}}MBを超えています',
      failed: 'アップロードに失敗しました',
    },
  viewer: {
      selectModel: 'モデルを選択してください',
      loadFailed: '3Dモデルの読み込みに失敗しました',
      retry: '再試行',
      loading: '読み込み中...',
      hideGrid: 'グリッド非表示',
      showGrid: 'グリッド表示',
      showSolid: 'ソリッド表示',
      showWireframe: 'ワイヤフレーム表示',
      fit: 'フィット',
      reset: 'リセット',
      selectPartPoint: '部位として登録する位置をクリック',
    },
  chat: {
      selectModel: 'モデルを選択してチャットを開始',
      guidance: 'CADモデルについて質問できます',
      sampleSize: 'この部品のサイズ感は？',
      sampleManufacturing: '製造方法の提案は？',
      sampleQuality: '品質チェックポイントは？',
      placeholder: '質問を入力...',
      error: 'エラーが発生しました。もう一度お試しください。',
      threadCompareTitle: '[3DCAD] 比較: {{modelA}} vs {{modelB}}',
      threadTitle: '[3DCAD] {{model}}',
    },
  ai: {
      selectModel: 'モデルを選択してください',
      title: 'AI分析',
      analyzing: '分析中...',
      reanalyze: '再分析',
      reanalyzeConfirm: {
        title: 'AI解析をやり直す',
        description:
          '既存のAI解析結果を上書きします。以前の内容は復元できません。やり直してもよろしいですか？',
        confirm: 'やり直す',
      },
      start: '分析開始',
      description: 'GPT-4による設計・製造観点の分析を実行します',
      failed: 'AI分析に失敗しました',
    },
  marker: {
      source: {
        pre_label: '事前ラベル',
        hotspot: '解析ホットスポット',
        llm_inferred: 'LLM推定',
      },
    },
  markerDetail: {
      title: '失敗モード詳細',
      noData: 'この位置に紐づくDRBFMデータがありません。',
      groupedCount: '{{count}}件の失敗モードが同じ位置に紐づいています。',
      confidence: '信頼度 {{value}}%',
      cause: '原因',
      effect: '影響',
      part: '部位',
      locationEvidence: '位置紐づけ根拠',
      relatedDocuments: '関連技術文書',
    },
  metadata: {
      empty: 'メタデータなし',
      title: 'メタデータ',
      dimensions: '寸法',
      boundingBox: 'バウンディングボックス',
      volume: '体積',
      surfaceArea: '表面積',
      geometry: '形状',
      triangleCount: '三角形数',
      vertexCount: '頂点数',
      edgeCount: 'エッジ数',
      faceCount: '面数',
      file: 'ファイル',
      originalFormat: '元フォーマット',
      originalFileSize: '元ファイルサイズ',
      glbSize: 'GLBサイズ',
      nonWatertightMesh: '非水密メッシュ',
      wallThickness: '壁厚分析',
      confidence: {
        high: '高信頼',
        medium: '近似値',
        low: '低信頼',
      },
      min: '最小',
      median: '中央値',
      mean: '平均',
      max: '最大',
      thinAreas: '薄肉箇所',
      detectedCount: '{{count}}件検出',
      meshQuality: 'メッシュ品質',
      watertight: '水密性',
      yes: 'あり',
      no: 'なし',
      bodyCount: 'ボディ数',
      degenerateFaces: '退化面',
      draftRisk: '抜き勾配リスク',
      undercutFraction: 'アンダーカット率',
      riskRegionCount: 'リスク領域数',
      count: '{{count}}件',
      pullDirection: '抜き方向',
      analysisScope: '解析スコープ',
      target: '対象',
    },
};

export default panels;
